import React, { FunctionComponent } from "react";
import styled from "styled-components";
import ArrowRightIcon from "src/components/icons/ArrowRight";
import Step from "./Step/Step";

interface Breadcrumb {
    steps: string[];
    current?: number | null;
}

const Root = styled("div")`
    display: flex;
`;

const StepContainer = styled("div")`
    align-items: center;
    display: flex;
`;

export const ArrowContainer = styled(ArrowRightIcon)`
    color: #b7b7b7;
    height: 13px;
    margin-left: 16px;
    margin-right: 24px;
    width: 13px;
`;

const Breadcrumb: FunctionComponent<Breadcrumb> = ({ steps, current }) => {
    return (
        <Root>
            {steps.map((m, index) => (
                <StepContainer key={m}>
                    <Step name={m} current={current === index} />

                    {index < steps.length - 1 && <ArrowContainer />}
                </StepContainer>
            ))}
        </Root>
    );
};

export default Breadcrumb;
